// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"97":"aboutUs","114":"companyWorth","187":"JoinUs","364":"CustomerStories","443":"about","465":"industryTrends","994":"companyBusiness"}[chunkId] + "." + {"97":"37cfe22b","114":"12b51916","187":"589d8d4f","364":"96a139d9","443":"2a888f8a","465":"9dd56f00","994":"a3dc9e86"}[chunkId] + ".css";
};